import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

import { basicInfoSchema, questionsStepSchema } from "./CreateScaleSchema";
import { ScalesContext } from "../../context/ScalesContext/ScalesContext";

import { apiInterceptor } from "../../services/interceptors/jwt.interceptor";
import { checkScaleSchema } from "../../custom/scaleValidations";

import Modal from "../../atoms/Modal";
import Spinner from "../../atoms/Spinner";
import ModalContent from "../../atoms/ModalContent";
import ScaleAdminStep from "../../organisms/ScaleAdminStep";
import { BasicInfoStep } from "../../molecules/BasicInfoStep";
import { QuestionsStep } from "../../molecules/QuestionsStep";
import ScaleAdminStepper from "../../organisms/ScaleAdminStepper";

import infoGreenIcon from "../../assets/imgs/icons/infoGreenIcon.svg";
import infoRedIcon from "../../assets/imgs/icons/InfoIcon.svg";

export const AdminStepper = ({ initialValues }) => {
  const navigate = useNavigate();
  const { editScale, setIsEditScale, setScaleName } = useContext(ScalesContext);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [statusEdit, setStatusEdit] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [status, setStatus] = useState(false);
  const [error, setError] = useState("");
  const [defaultMessage, setDefaultMessage] = useState("");
  const handleClosePopup = () => {
    setOpenPopup(false);
    navigate("/formularios");
  };

  return (
    <>
      <ScaleAdminStepper
        initialValues={initialValues}
        onSubmit={async (values, { setErrors }) => {
          let validate = false;

          let questionList = [];
          let copyQuestions = values.schema;

          for (let q of copyQuestions) {
            if (q.question) {
              if (q?.question?.to_delete && q?.question?.id) {
                questionList.push(q);
              } else if (!q?.question?.to_delete) {
                questionList.push(q);
              }
            } else if (q.section) {
              if (q.section.to_delete && q.section.idSection) {
                questionList.push(q);
              } else if (!q.section.to_delete) {
                questionList.push(q);
              }
            }
          }

          const { questionErrors, errorMessage, submitValidation } = checkScaleSchema(questionList);
          setErrors({ schema: questionErrors, general: errorMessage });

          const questionSchemaIsOk = !submitValidation.length && !errorMessage;
          if (questionSchemaIsOk) validate = true;

          if (validate) {
            const lines = [];

            const listLines = values.service_lines.length
              ? values.service_lines
              : [];

            for (let opt of listLines) {
              opt.to_delete
                ? lines.push({
                  id: opt.line.key,
                  frequency_days: {
                    ingress_date: opt?.frequency_days?.income_frecuency
                      ? opt?.frequency_days?.income_frecuency?.map((day) =>
                        parseInt(day.key)
                      )
                      : [],
                    egress_date: opt?.frequency_days?.egress_frecuency
                      ? opt?.frequency_days?.egress_frecuency?.map((day) =>
                        parseInt(day.key)
                      )
                      : [],
                  },
                  to_delete: opt.to_delete,
                })
                : lines.push({
                  id: opt.line.key,
                  frequency_days: {
                    ingress_date: opt?.frequency_days?.income_frecuency
                      ? opt?.frequency_days?.income_frecuency?.map((day) =>
                        parseInt(day.key)
                      )
                      : [],
                    egress_date: opt?.frequency_days?.egress_frecuency
                      ? opt?.frequency_days?.egress_frecuency?.map((day) =>
                        parseInt(day.key)
                      )
                      : [],
                  },
                });
            }

            const sendPatient =
              values.modules.map((module) => module.key).length === 1 &&
                values.modules.find((module) => module.key === 101)
                ? true
                : values.send_to_patient === "true"
                  ? true
                  : false;

            const payloadScale = {
              name: values.name,
              service_lines: lines,
              description: values.description,
              age_range: values.age_range,
              time_complete: parseInt(values.time_complete),
              bibliografy: values.bibliografy,
              image: values.image ? values.image : "",
              modules: values.modules.map((module) => module.key),
              threshold: values?.threshold ? parseInt(values?.threshold) : null,
              send_to_patient: sendPatient,
              schema: questionList,
            };

            const newScale = {
              ...payloadScale,
            };

            const id = editScale.id ? editScale.id : null;
            if (id === "nuevaEscala" || id === null) {
              setScaleName(values.name);
              setLoadingUpdate(true);
              setOpenPopup(true);
              setDefaultMessage("Error creando formulario,\ninténtalo de nuevo");

              const data = await apiInterceptor({
                method: "POST",
                endpoint: "/tr/admin/forms",
                data: newScale,
              });

              setLoadingUpdate(false);
              if (data.data === undefined) {
                setError(data.message);
                setIsEditScale(false);
                setStatus(data.response[0].id ? true : false);
              }
              if (data.statusCode === 201) {
                setIsEditScale(false);
                setStatus(data.data[0].message ? true : false);
              } else if ([400, 404, 500].includes(data.statusCode)) {
                setError(data?.message);
                setStatus(data.response[0].id ? true : false);
              }
            } else {
              setDefaultMessage("Error editando formulario,\ninténtalo de nuevo")
              setLoadingUpdate(true);
              setScaleName(values.name);
              const id = editScale.id;
              setOpenPopup(true);
              const data = await apiInterceptor({
                method: "PUT",
                endpoint: `/tr/admin/forms/${id}`,
                data: payloadScale,
              });
              if (data.statusCode === 200) {
                setIsEditScale(false);
                setStatusEdit(data.statusCode);
              } else if ([400, 404, 500].includes(data.statusCode)) {
                setError(data?.message);
                setStatusEdit(data.statusCode);
              }
              setLoadingUpdate(false);
            }
          }
        }}
      >
        <ScaleAdminStep validationSchema={Yup.object(basicInfoSchema)}>
          <BasicInfoStep />
        </ScaleAdminStep>

        <ScaleAdminStep validationSchema={Yup.object(questionsStepSchema)}>
          <QuestionsStep />
        </ScaleAdminStep>
      </ScaleAdminStepper>

      <Modal
        isOpen={openPopup}
        onClose={() => handleClosePopup()}
        variant="confirm"
      >
        {loadingUpdate ? (
          <Spinner className_container="rolesForm" />
        ) : (
          <ModalContent
            close={() => handleClosePopup()}
            text={
              status
                ? "Formulario creado\nexitosamente"
                : statusEdit === 200
                  ? "Formulario editado\nexitosamente"
                  : defaultMessage
            }
            icon={status || statusEdit === 200 ? infoGreenIcon : infoRedIcon}
            btns={false}
            alt="Icono creación o edición de formulario"
            helpText={error}
            helpStyles={{
              marginBottom: 0
            }}
          />
        )}
      </Modal>
    </>
  );
};
